import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { ArticuloTransferencia, ArticuloTransferenciaTipo } from "@/shared/types/articulo-transferencia";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface ArticuloTransferenciasQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
    tipo?:ArticuloTransferenciaTipo
}

export async function getAllArticuloTransferencias(query?: ArticuloTransferenciasQuery): Promise<QueryResponse<ArticuloTransferencia>> {
    await sleep(1000);
    const response = await api.get("articulo_transferencias", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllArticuloTransferenciasQuery(query: ArticuloTransferenciasQuery = {}, queryConfig: QueryConfig<QueryResponse<ArticuloTransferencia>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllArticuloTransferencias(query),
        queryKey: ["articulo_transferencias", query],
    })
}

export interface GetAllArticuloTransferenciaQueryProps {
    query: ArticuloTransferenciasQuery,
    queryConfig?: QueryConfig<QueryResponse<ArticuloTransferencia>>,
    children: (queryResult: QueryResult<QueryResponse<ArticuloTransferencia>>) => ReactNode
}

export function GetAllArticuloTransferenciasQuery({
    query,
    queryConfig,
    children
}: GetAllArticuloTransferenciaQueryProps) {
    const queryResult = useGetAllArticuloTransferenciasQuery(query, queryConfig);
    return children && children(queryResult);
}